module.exports = __webpack_public_path__ + "img/5.f57dda33.png";